
import { mapActions, mapState } from "vuex";
import currencyConverter from "../common/currency-converter.vue";
import ConfirmationDialog from "../dialogs/confirmation-dialog.vue";

export default {
  components: { currencyConverter, ConfirmationDialog },
  props: {
    item: {
      default: () => {},
      type: Object
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showGroupDeleteConfirmationDialog: false,
      selectedGroup: null
    };
  },

  computed: {
    ...mapState("menu", ["addons"]),
    groupInfos() {
      return this.id === "set-choices" ? this.item.choices : this.item.addons;
    }
  },
  methods: {
    getSelectedAddons(selectedItems) {
      return this.id === "set-choices"
        ? selectedItems
        : selectedItems.map((itemId) =>
            this.addons.find((addon) => addon?.id === itemId)
          );
    },
    handleDeleteGroup() {
      this.showGroupDeleteConfirmationDialog = false;
      this.$emit("delete-group-from-item", {
        itemId: this.item?.id,
        index: this.selectedIndex
      });
      this.showGroupDeleteConfirmationDialog = false;
      this.selectedIndex = null;
    },
    modifyGroup(index) {
      this.$emit("show-create-group-dialog", {
        groupInfo: this.groupInfos[index],
        index: index
      });
    },
    handleShowDeleteGroupConfirmation(index) {
      this.selectedIndex = index;
      this.showGroupDeleteConfirmationDialog = true;
    }
  }
};
